import React from 'react';

interface BeforeAfterViewProps {
  images: string[];
  onImageClick: (images: string[], index: number) => void;
  altDescription: string;
}

function BeforeAfterView({images, onImageClick, altDescription}: BeforeAfterViewProps) {
  return (
    <div className="grid grid-cols-2 max-w-4xl mx-auto gap-y-4 gap-x-3 mt-8 px-4">
      <h4 className="text-center text-lg font-display font-semibold text-navy">Before</h4>
      <h4 className="text-center text-lg font-display font-semibold text-navy">After</h4>
      {images.map((image, index) => (
        <div key={index} className="aspect-[4/3] overflow-hidden cursor-pointer group" onClick={() => onImageClick(images,index)}>
          <img className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-[1.03]" src={image.toString()} alt={altDescription}/>
        </div>
      ))}
    </div>
  );
}

export default BeforeAfterView;
